export const AB_COWORKING_POPUP_EXPERIMENT = 'ab_coworking_popup';
export const COWORKING_SNIPPETS_EXPERIMENT = 'coworking_snippets';
